/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CriteriaQualifier } from './CriteriaQualifier';
import {
    CriteriaQualifierFromJSON,
    CriteriaQualifierFromJSONTyped,
    CriteriaQualifierToJSON,
    CriteriaQualifierToJSONTyped,
} from './CriteriaQualifier';

/**
 * 
 * @export
 * @interface CriteriaTargetInput
 */
export interface CriteriaTargetInput {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    category_id?: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    qualifier: CriteriaQualifier;
    /**
     * 
     */
    is_medication_rule?: boolean;
}



/**
 * Check if a given object implements the CriteriaTargetInput interface.
 */
export function instanceOfCriteriaTargetInput(value: object): value is CriteriaTargetInput {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('qualifier' in value) || value['qualifier'] === undefined) return false;
    return true;
}

export function CriteriaTargetInputFromJSON(json: any): CriteriaTargetInput {
    return CriteriaTargetInputFromJSONTyped(json, false);
}

export function CriteriaTargetInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaTargetInput {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'category_id': json['category_id'] == null ? undefined : json['category_id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'qualifier': CriteriaQualifierFromJSON(json['qualifier']),
        'is_medication_rule': json['is_medication_rule'] == null ? undefined : json['is_medication_rule'],
    };
}

export function CriteriaTargetInputToJSON(json: any): CriteriaTargetInput {
    return CriteriaTargetInputToJSONTyped(json, false);
}

export function CriteriaTargetInputToJSONTyped(value?: CriteriaTargetInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'category_id': value['category_id'],
        'name': value['name'],
        'description': value['description'],
        'qualifier': CriteriaQualifierToJSON(value['qualifier']),
        'is_medication_rule': value['is_medication_rule'],
    };
}

